/**
 * Csv Schema of EsconderMotorista
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {EsconderMotorista} from '@/model/resource/EsconderMotorista'

/* TODO: review generated schema */
export class CsvEsconderMotoristaSchema extends Schema {
  readonly name = 'CsvEsconderMotorista'

  readonly fieldSet: FieldSet<EsconderMotorista> = {
    idEsconderMotoristaPk: schema => schema.model.idEsconderMotoristaPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    data: schema => Helper.datetime(schema.model.data),
  }
}
